module.exports = __webpack_public_path__ + "static/media/dorodouli_tsipouro_and_spirits_aspro_app.c94f785a.png";